import { render, staticRenderFns } from "./wty-table.vue?vue&type=template&id=b6e12a22&scoped=true&"
import script from "./wty-table.vue?vue&type=script&lang=js&"
export * from "./wty-table.vue?vue&type=script&lang=js&"
import style0 from "./wty-table.vue?vue&type=style&index=0&id=b6e12a22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e12a22",
  null
  
)

export default component.exports